// Typed client for the public developer profile endpoints. The profile powers
// the showcase /dev/<slug> page and is edited from Account > Public profile.
import { apiGet, apiPut, ApiHttpError } from './api';

export interface DevProfileSettings {
  studio_name: string;
  slug: string;
  bio: string;
  website: string;
}

export interface PublicDevProfile extends DevProfileSettings {
  joined: string | null;
  games: {
    slug: string;
    name: string;
    visibility: string;
    /** Set only when the game has a *public* wiki. */
    wiki: { slug: string; url: string } | null;
  }[];
}

/**
 * The signed-in tenant's profile; null once confirmed there isn't one yet
 * (a 404). A transient network/server failure rethrows instead of being
 * indistinguishable from "no profile" - the caller would otherwise render
 * an empty "set up your profile" form over a profile that actually exists.
 */
export async function getDevProfile(): Promise<DevProfileSettings | null> {
  try {
    return await apiGet<DevProfileSettings>('/me/dev-profile');
  } catch (err) {
    if (err instanceof ApiHttpError && err.status === 404) return null;
    throw err;
  }
}

export function updateDevProfile(profile: DevProfileSettings): Promise<DevProfileSettings> {
  return apiPut('/me/dev-profile', profile);
}

/** Public, unauthenticated view used by the showcase. */
export function getPublicDevProfile(slug: string): Promise<PublicDevProfile> {
  return apiGet(`/public/devs/${slug}`);
}
